import { call, select, put, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { types } from '@actions/conference';
import { getTranscriptByLinksUUID } from '@services/conferenceResource';
import { tokenSelector, otpSelector } from '@selectors/authentication';
import {
  blockTwoFactorAuthForm,
  unblockTwoFactorAuthForm,
  attemptsCountExhausted,
} from '@actions/authentication';
import { ERROR_MESSAGES } from '@config/api-messages';
import _ from 'lodash';

export function* transcriptGetByLinksUUIDSaga(action) {
  try {
    const token = yield select(tokenSelector);
    const otp = yield select(otpSelector);
    const transcriptResponse = yield call(getTranscriptByLinksUUID, action, token, otp);
    yield put({
      type: types.GET_BY_LINKS_UUID.SUCCESS,
      transcript: transcriptResponse.data.transcript,
    });
    yield put(unblockTwoFactorAuthForm());
  } catch (err) {
    const attemptsCountReached =
      _.get(err, 'response.data.error.name') === ERROR_MESSAGES.ACCOUNT_BLOCKED;

    if (!attemptsCountReached) {
      yield put(unblockTwoFactorAuthForm());
      yield put({
        type: types.GET_BY_LINKS_UUID.FAILURE,
        message:
          _.get(err, 'response.data.error.message') ||
          err.message ||
          ERROR_MESSAGES.CANT_FETCH_TRANSCRIPT,
      });
    } else {
      yield put(blockTwoFactorAuthForm());
      yield put(attemptsCountExhausted());
      yield put({
        type: types.GET_BY_LINKS_UUID.FAILURE,
        message:
          (attemptsCountReached && ERROR_MESSAGES.ATTEMPTS_EXHAUSTED_MESSAGE) ||
          _.get(err, 'response.data.error.message') ||
          err.message ||
          ERROR_MESSAGES.CANT_FETCH_TRANSCRIPT,
      });
    }
    if (err.response && err.response.status === 403) {
      if (action.isAIRoute) {
        yield put(push(`/two-factor-auth?uuid=${action.uuid}&type=ai-route`));
      } else {
        yield put(push(`/two-factor-auth?uuid=${action.uuid}`));
      }
    }
    if (err.response && err.response.status === 401) {
      yield put(push('/no-permission'));
    }
  }
}

export default function* transcriptGetById() {
  yield takeEvery(types.GET_BY_LINKS_UUID.STARTED, transcriptGetByLinksUUIDSaga);
}



// WEBPACK FOOTER //
// ./redux/sagas/transcriptGetByLinksUUID.js